<svg xmlns="http://www.w3.org/2000/svg" viewBox="433.223 168.958 31.578 31.001">
  <path
    fill="#662113"
    d="m440.306 174.928.55-.372v-.395a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v1.868l.632.428-.632.427v4.277h3V175.3l-.55-.372Z"
  />
  <path
    fill="#D99E82"
    d="M462.012 187.959v-5l-5.965-5.965-2.41 1.507.167-3.75-4.792-4.792-13 13v7h2v1h-2v9h26v-5.5h-1v-1h1v-4.5h-2v-1h2Z"
  />
  <path
    fill="#C1694F"
    d="M441.012 192.959h4v6h-4v-6Zm0-9h4v4h-4v-4Zm12.5 9h4v4h-4v-4Z"
  />
  <path
    fill="#292F33"
    d="m464.508 183.809-7.591-7.359-1.74 1.088 7.917 7.685a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Zm-10.643-10.412-4.146-4.146a.999.999 0 0 0-1.414 0l-14.789 14.843a.999.999 0 1 0 1.414 1.414l14.082-14.135 4.732 4.732.121-2.708Z"
  />
  <path
    fill="#662113"
    d="m455.432 177.379-1.795 1.122.125-2.792-1.979-1.979-1.625 7.417 3.687 1.729-2.75 7.666 6.917-6.583-1-5-1.58-1.58Zm-15.423 8.498 5.58-1.722.428 1.389-5.58 1.721-.428-1.388Zm-.318 10.848 5.753-2.952.664 1.293-5.754 2.952-.663-1.293Zm18.489-.274-5.58-1.722.429-1.388 5.58 1.721-.429 1.389Z"
  />
  <path
    fill="#662113"
    d="m445.74 198.005-5.99-2.705.597-1.324 5.99 2.704-.597 1.325Z"
  />
</svg>
